import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createActivity, provisionUser } from '../../util/api';
import { logoutThunk } from '../../ducks/auth.duck';

// ─── Async Thunks ───

const createActivityThunk = createAsyncThunk(
  'CreateActivityPage/createActivity',
  async (body: any, { rejectWithValue, dispatch }) => {
    try {
      const r = await createActivity(body);
      return r.data || r;
    } catch (e: any) {
      if (e.status === 401) {
        dispatch(logoutThunk());
        return rejectWithValue('Session expired. Please log in again.');
      }
      if (e.status === 403) {
        try {
          await provisionUser();
          const retry = await createActivity(body);
          return retry.data || retry;
        } catch (retryErr: any) {
          return rejectWithValue(retryErr.message || 'Failed after RBAC provisioning');
        }
      }
      return rejectWithValue(e.message || 'Failed to create activity');
    }
  }
);

// ─── Slice ───

const slice = createSlice({
  name: 'CreateActivityPage',
  initialState: {
    submitting: false,
    submitError: null as string | null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(createActivityThunk.pending, s => { s.submitting = true; s.submitError = null; })
      .addCase(createActivityThunk.fulfilled, s => { s.submitting = false; })
      .addCase(createActivityThunk.rejected, (s, a) => { s.submitting = false; s.submitError = a.payload as string; });
  },
});

export default slice.reducer;

// ─── Exported Thunks ───

export const submitActivity = (body: any) => (dispatch: any) =>
  dispatch(createActivityThunk(body)).unwrap();

// ─── loadData ───

export const loadData = () => () => Promise.resolve();

// ─── Selectors ───

export const selectSubmitting = (s: any) => s.CreateActivityPage?.submitting || false;
